var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 198,
    viewBox: "0 0 442 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.305 -85H391.889V97.2363H395.305V-85Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403.063 82.0449H384.109V94.8619H403.063V82.0449Z",
    fill: "#DBDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M403.063 86.311H384.109V94.8621H403.063V86.311Z",
    fill: "#C7C7C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396.935 193.882C404.779 192.036 409.642 184.18 407.797 176.335C405.951 168.49 398.095 163.626 390.251 165.472C382.406 167.318 377.543 175.174 379.389 183.019C381.235 190.865 389.09 195.728 396.935 193.882Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M441.087 179.678H346.105L363.303 149.199L377.335 92.5845H409.857L423.889 149.199L441.087 179.678Z",
    fill: "#DBDBDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.698 -85H215.281V67.2592H218.698V-85Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.475 52.0679H207.521V64.8848H226.475V52.0679Z",
    fill: "#DBDBDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.475 56.334H207.521V64.8851H226.475V56.334Z",
    fill: "#C7C7C7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 149.701C231.59 157.769 225.066 164.293 216.998 164.293C208.93 164.293 202.406 157.769 202.406 149.701C202.406 141.632 208.93 135.108 216.998 135.108C225.066 135.108 231.59 141.632 231.59 149.701Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M264.48 149.701H169.518L186.715 119.222L200.747 62.6074H233.25L247.282 119.222L264.48 149.701Z",
    fill: "#DBDBDB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3109 -85H45.8945V35.9504H49.3109V-85Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.069 20.7593H38.1152V33.5762H57.069V20.7593Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.069 25.0254H38.1152V33.5765H57.069V25.0254Z",
    fill: "#C7C7C7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1834 118.392C62.1834 126.441 55.6596 132.985 47.5917 132.985C39.5238 132.985 33 126.461 33 118.392C33 110.324 39.5238 103.799 47.5917 103.799C55.6596 103.799 62.1834 110.324 62.1834 118.392Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0927 118.392H0.111328L17.3087 87.8937L31.3407 31.2983H63.8633L77.876 87.8937L95.0927 118.392Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamps);
export default __webpack_public_path__ + "static/media/lamps.0cba5cc5be15e94857308596c45aa9a0.svg";
export { ForwardRef as ReactComponent };